import type { JSX } from 'react';
import { ConfigSection } from '../components/ConfigSection.js';

export function PrivacyPage(): JSX.Element {
  return (
    <ConfigSection
      title={"Privacidade: casos, consentimentos e jobs de dados"}
      description={"Área do plano que depende de código ou credencial externa."}
      blockedBy={[
      'Export/delete (F-13) modelados mas sem endpoints nem worker handler.',
      'Revisão humana de privacidade e representação é exigida antes do piloto (§17) e não pode ser simulada.'
]}
      planned={[
      'Exportação temporária de 7 dias, exclusão com tombstone e retenções explicadas.',
      'Acesso excepcional a conteúdo exige motivo, prazo, escopo e log.'
]}
    />
  );
}